<template>
  <div class="workbench-component-order-done-container default-table">
    <el-form :inline="true" :model="formSearch" size="mini">
      <el-form-item label="客户名称" class="form-item-customer">
        <el-input v-model="formSearch.customer_name" placeholder="客户名称" clearable/>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input v-model="formSearch.order_no" placeholder="订单号" clearable/>
      </el-form-item>
      <el-form-item label="系统编号">
        <el-input v-model="formSearch.covenant_no" placeholder="系统编号" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getTableData">查询</el-button>
      </el-form-item>
    </el-form>
    <div ref="main" style="border: 1px solid rgba(255, 49, 118, 0.2);height: calc(100% - 90px);overflow-y: auto;">
      <table v-for="(datum,datumIndex) in tableData" :key="datumIndex" class="table-container">
        <tbody class="table-contract" @click="datum.dom_open = !datum.dom_open">
        <tr>
          <td width="26%" style="padding-left: 20px;"> {{ datumIndex + 1 }}. 系统编号：{{ datum.covenant_no }}
            <span style="color: #8492a6; font-size: 12px">「{{ datum.orders ? datum.orders.length : 0 }}个订单」</span>
          </td>
          <td colspan="3">
            {{ datum.covenant_title }}
            <span style="color: #8492a6; font-size: 12px">「{{ datum.customer_name }}」</span>
          </td>
          <td colspan="1" style="text-align: right;padding-right: 20px;">
            <span v-if="userAuth.can_see_covenant_files" class="span-btn" @click="handelPreview(datum)">查看附件</span>
            <span v-if="userAuth.can_todo_sign_covenants" class="span-btn" style="margin-left: 10px;"
                  @click="handelAddOrder(datum)">追加订单</span>
            <i class="animate__animated"
               :class="datum.dom_open?'el-icon-arrow-down animate__rotateIn':'el-icon-arrow-up'"
               style="margin-left: 20px;"/>
          </td>
        </tr>
        </tbody>
        <tbody class="animate__animated" :class="`${datum.dom_open?'animate__fadeIn':''}`" v-if="datum.dom_open">
        <tr v-for="(order,orderIndex) in datum.orders" :key="orderIndex"
            class="tr-order" :class="{active:formSearch.order_no===order.order_no}"
            :ref="formSearch.order_no===order.order_no?'TrActive':''"
            :style="`${formSearch.order_no===order.order_no?'background:yellow':''}`"
        >
          <td style="padding-left: 20px;">
            <div>
              订单编号： {{ order.order_no }}
            </div>
            <div class="flag">
              <span
                  v-for="field in ['form_of_cooperation', 'product_category', 'trade', 'order_source', 'customer_nature', 'passenger_order_interval']"
                  :key="orderIndex + field">
                <template v-if="order[field]">#{{ order[field] }}&emsp14;&emsp14;</template>
              </span>
            </div>
          </td>
          <td>
            <div>红人昵称：{{ order.artist_name }}</div>
            <div>产品/内容：{{ order.product }}</div>
            <div>品牌：{{ order.brand }}</div>
          </td>
          <td>
            <div>含税价：{{ order.payment_account|numberFormat }}</div>
          </td>
          <td>
            <div>销售：{{ order.sale }}</div>
            <div>执行：{{ order.executor }}</div>
          </td>
          <td style="display: flex;align-items: center;justify-content: space-between;padding-right: 20px;">
            <div>
              <div>要求发布时间：{{ order.release_timestamp|parseTime }}</div>
              <div>下单时间：{{ order.created_timestamp|parseTime }}</div>
              <div>执行时间：{{ order.exec_timestamp|parseTime }}</div>
            </div>
            <el-popover v-if="userAuth.can_undo_sign_covenants" placement="left" trigger="click"
                        :ref="`popover-` + order.order_no">
              <div>
                <div>确认移除吗?</div>
                <div style="margin-top: 20px;text-align: center;">
                  <el-button slot="reference" size="mini" @click="handelRemoveOrder(order,false)">取消</el-button>
                  <el-button type="primary" slot="reference" size="mini" @click="handelRemoveOrder(order,true)">确定
                  </el-button>
                </div>
              </div>
              <span slot="reference" class="span-btn">移除</span>
            </el-popover>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <el-pagination
        background
        :current-page="formSearch.page"
        :page-size="formSearch.per_page"
        layout="total, prev, pager, next"
        :total="formSearch.total"
        @current-change="handleCurrentChange"
        style="margin-top: 10px;float: right;"
    />
    <el-dialog title="追加订单" :visible.sync="dialogStore" width="580px" center>
      <div>请输入为【{{ formStore.covenant_title }}】追加的订单编号</div>
      <el-input v-model="formStore.order_no" placeholder="请输入订单编号"/>
      <span slot="footer" class="dialog-footer">
           <el-button @click="dialogStore = false">取 消</el-button>
           <el-button type="primary" @click="handelStoreSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {optionsSaleCustomers} from "@/api/customers";
import {orderCovenantDoSign, orderCovenantSignPage, orderCovenantUnDoSign} from "@/api/orderCovenant";

const ModelFormStore = {
  covenant_id: null,
  covenant_title: null,
  customer_name: null,
  order_no: null,
}
const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).value : {id: -1}
const user_id = user.id

export default {
  name: "WorkbenchComponentOrdersDone",
  inject: ["refreshSummation"],
  data() {
    return {
      dialogStore: false,
      formSearch: {
        page: 1,
        per_page: 10,
        total: 0,
        customer_name: null,
        order_no: null,
        covenant_no: null,
      },
      tableData: [],
      optionsCustomers: [],
      formStore: {...{}, ...ModelFormStore},
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  created() {
    this.getTableData()
  },
  methods: {
    handelPreview(obj) {
      const {href} = this.$router.resolve({
        name: `FilesPreview`,
        query: {
          covenant_title: obj.covenant_title,
          covenant_id: obj.id,
        }
      });
      window.open(href, "_blank");
    },
    callbackSuccess() {
      this.refreshSummation();
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.formSearch.page = val
      this.getTableData()
    },
    async getTableData() {
      const response = await orderCovenantSignPage(this.formSearch)
      const tableData = response.data.list || [];
      this.formSearch.total = response.data.pages.total || 0;
      tableData.map((_, i) => {
        _.dom_open = i === 0
      })
      this.tableData = tableData
      if (this.$refs.TrActive && this.$refs.TrActive[0]) {
        this.$refs.main.scrollTop = this.$refs.TrActive[0].offsetTop
      }
    },
    /**
     * 移除订单
     * @param obj
     * @param isSure
     * @returns {Promise<boolean>}
     */
    async handelRemoveOrder(obj, isSure) {
      const dom = this.$refs[`popover-` + obj.order_no]
      if (!isSure) {
        dom && dom[0] && (dom[0].showPopper = false)
        return false;
      }
      const response = await orderCovenantUnDoSign({order_nos: [obj.order_no]})
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return false;
      }

      dom && dom[0] && (dom[0].showPopper = false)
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      await this.callbackSuccess()
    },
    handelAddOrder(obj) {
      this.formStore.covenant_id = obj.id
      this.formStore.covenant_title = obj.covenant_title
      this.formStore.customer_name = obj.customer_name
      this.formStore.order_no = null
      this.dialogStore = true;
    },
    async handelRemoteCustomer(query) {
      const response = await optionsSaleCustomers({customer_name: query, sale_id: user_id})
      this.optionsCustomers = response.model || []
    },
    async handelStoreSure() {
      if (!this.formStore.order_no) {
        this.showToast({h: this, icon: "el-icon-error", text: '请输入订单编号', duration: 1000});
        return false;
      }
      const response = await orderCovenantDoSign({
        covenant_id: this.formStore.covenant_id,
        order_nos: [this.formStore.order_no]
      })
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      await this.callbackSuccess()
      this.dialogStore = false;
    },
  }
}
</script>

<style lang="scss">
.workbench-component-order-done-container {
  height: 100%;

  .el-upload {
    width: 100%;

    .el-upload-dragger {
      width: 100%;
    }
  }

  .table-container {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    color: #3c3c3c;
    table-layout: fixed;
    padding-left: 20px;

    td, th {
      padding-top: 10px;
      padding-bottom: 10px;
      vertical-align: center;
    }

    .table-contract {
      background: #ffe5ed;
      cursor: pointer;
    }
  }

  .table-container {
    margin-bottom: 8px;
  }

  .tr-order {
    border-bottom: 1px dashed #ffe5ed;

    .flag {
      span {
        color: #8a8e99;
      }
    }
  }
}
</style>
